import React from "react";
import style from "./FunctionModal.module.css";
import { ReactComponent as Close } from "../../../assets/x.svg";
import { useEffect, useState } from "react";
import DropdownInput from "../../../components/DropDownInput/DropdownInput";
import TextInput from "../../../components/TextInput";
import Button from "../../../components/Button";
import Spacer from "../../../components/Spacer";
import { getPreferredFieldName } from "../lookups/getPreferredFieldName";
import { useTranslation } from "react-i18next";

const FunctionModal = ({ reportObj, operands, onDone, onClose }) => {
  const { t } = useTranslation("reportFunctions");

  const operators = [
    { type: "ADDITION", description: "+" },
    { type: "SUBTRACTION", description: "-" },
    { type: "MULTIPLICATION", description: "x" },
    { type: "DIVISI0N", description: "/" },
  ];

  const [operator, setOperator] = useState(operators[0]);
  const [name, setName] = useState("");
  const [functionNames, setFunctionNames] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let tempFunctionNames = [];
    if (reportObj?.functionFields) {
      reportObj.functionFields.forEach((field) => {
        if (field?.name) {
          tempFunctionNames.push(field.name);
        }
      });

      setFunctionNames(tempFunctionNames);
    }
  }, [reportObj]);

  useEffect(() => {
    // checks if a function name starts with a letter and contains only letters and numbers
    const pattern = /^[a-zA-z]+[A-Za-z0-9]*$/;
    if (name && functionNames.includes(name)) {
      setError(t("existingFunctionError"));
    } else if (name && !pattern.test(name)) {
      setError(t("invalidFunctionNameError"));
    } else {
      setError("");
    }
  }, [name]);

  const handleApply = () => {
    onDone(operator, name);
    setName("");
  };

  return (
    <div className={style["FunctionModal__overlay"]}>
      <div className={style["FunctionModal__modal"]}>
        <Close
          fill={"#121A2D"}
          className={style["FunctionModal__close"]}
          onClick={() => {
            onClose();
          }}
        />
        <div className={style["FunctionModal__header"]}>
          <h1>{t("builderTitle")}</h1>
        </div>
        <br />
        <div className={style["FunctionModal__body"]}>
          <div className={style["FunctionModal__textInputContainer"]}>
            <TextInput
              validationText={""}
              labelName={t("nameLabel")}
              placeholder={t("namePlaceholder")}
              value={name}
              type={"text"}
              onChange={(val) => setName(val)}
              focus={true}
              isEnabled={true}
            />
            {error && <p className={style["FunctionModal__error"]}>{error}</p>}
          </div>
          <div className={style["FunctionModal__row"]}>
            <TextInput
              validationText={""}
              labelName={t("field1Label")}
              placeholder={""}
              value={
                operands?.length === 2 &&
                // `${operands[0].collection}.${operands[0].name}`
                getPreferredFieldName(
                  operands[0].collection,
                  operands[0].name,
                  true,
                  false
                )
              }
              type={"text"}
              onChange={() => {}}
              focus={false}
              isEnabled={false}
            />
            <Spacer unit={"px"} space={20} />
            <DropdownInput
              value={operator.description}
              placeholder={t("operatorPlaceholder")}
              labelName={t("operatorLabel")}
              listElements={operators}
              validationText={""}
              onSelection={(operator) => {
                setOperator(operator);
              }}
            />
            <Spacer unit={"px"} space={20} />
            <TextInput
              validationText={""}
              labelName={t("field2Label")}
              placeholder={""}
              value={
                operands?.length === 2 &&
                // `${operands[1].collection}.${operands[1].name}`
                getPreferredFieldName(
                  operands[1].collection,
                  operands[1].name,
                  true,
                  false
                )
              }
              type={"text"}
              onChange={() => {}}
              focus={false}
              isEnabled={false}
            />
          </div>
        </div>
        <div className={style["FunctionModal__footer"]}>
          <Button
            onClick={() => {
              handleApply();
            }}
            labelName={t("applyButtonLabel")}
            isPrimary={true}
            isDisabled={name && !error ? false : true}
            minWidth={213}
          />
        </div>
      </div>
    </div>
  );
};

export default FunctionModal;
